import {  Divider } from '@mui/material'
import Form from '../../../components/Form'
import { useForm } from 'react-hook-form'
import FormItem from '../../../components/Form/FormItem'
import SelectOfCategories from '../../../components/Inputs/SelectOfCategories'
import InputNumber from '../../../components/Inputs/InputNumber'
import Button from '../../../components/General/Button'
import React from 'react'
import { useEffect, useState } from 'react'
import { RootState } from '../../../redux/store'
import { useDispatch, useSelector } from 'react-redux'
import { IGlobalRate } from '../../../views/Sells/Sells'
import { formatPipe } from '../../../utils/utils'
import { Components } from 'safe'
import CurrencyInput from '../../../components/Inputs/CurrencyInput'

interface ICashForm {
  onCancel: Function
  onSubmitProp: Function
  debt: number | string
  rate: IGlobalRate[]
}

export const CashForm : React.FC<ICashForm> = ({onCancel, onSubmitProp, rate, debt}) => {
  const accounts = useSelector((state: RootState) => state.acct.accounts)

  console.log("ACCOUNTS", accounts)

  const [listOfCash, setListOfCash] = useState<any[]>([])

  // const [listOfBills, setListOfBills] = useState<Bill[]>([])

  const form = useForm()

  const [selectedAccountCurrencyId, setSelectedAccountCurrencyId] = useState<any | null>(null)

  const onSubmit = (values): void => {
    // console.log('Valores de params', values)

    if (listOfCash.length === 0) {
      form?.setError('type', {
        type: 'manual',
        message: 'No hay opciones disponibles',
      })
      return
    }
    onSubmitProp({...values, amount: formatPipe(values.amount, true)})
  }

  const onGetAccountsCashFormatter = (): options[] => {
    return accounts.reduce((a, b) => {
      if (b.accountType === 'CASH') {
        return [...a, { text: b.description, value: b.id } as options]
      }
      return a as options[]
    }, [] as options[])
  }

  useEffect(() => {
    setListOfCash(onGetAccountsCashFormatter())
  }, [])

  return (
    <div>
      <label className="text-primary font-semibold mb-2">Efectivo</label>

      {/* <Divider />

      <div className="flex flex-row justify-between mt-2">
        <label>DEUDA</label>
        <label>Bs. 66,79</label>
      </div>

      <div className="flex flex-row justify-between mb-2">
        <label>DEUDA EN USD: (REF)</label>
        <label>$ 1,00</label>
      </div> */}

      <Divider />

      <Form
        classes="gap-x-6 mt-4"
        form={form}
        onSubmit={(values) => {
          onSubmit(values)
          console.log('VALUES', values)
        }}
      >
        <FormItem
          defaultValue={listOfCash[0]}
          name="type"
          classes={`col-span-12`}
        >
          <SelectOfCategories
            options={listOfCash}
            label="Cuenta receptora"
            onChange={(value : Components.SelectOption) => {
              let accountCurrency = accounts.find(v => v.id === value?.value)?.idCurrency
              let rateCurrency = rate.find(r => r.id === accountCurrency)?.rate || 1
              setSelectedAccountCurrencyId(accountCurrency)
              if (accountCurrency) {
                if (accountCurrency === "1") {
                  form.setValue('amount', `$ ${formatPipe((+debt / +rateCurrency).toFixed(2).replace('.', ','))}` )
                }

                if (accountCurrency === "2") {
                  form.setValue('amount', `Bs. ${formatPipe((+debt / +rateCurrency).toFixed(2).replace('.', ','))}` )
                }
              }
            
            }}  
          />
        </FormItem>

        <FormItem
          name="amount"
          classes={`col-span-12`}
          defaultValue={''}
          rules={{
            required: 'Es necesario el monto',
            // pattern: { value: /^\d+(\.\d{2})?$/, message: 'Monto inválido' },
          }}        >
          <CurrencyInput addDecimals={true} mask={selectedAccountCurrencyId === '1' ? '$ num' : 'Bs. num'} label='Monto' />
        </FormItem>

        <div className="col-span-12 flex mt-4">
            <Button
              type="outline"
              classes="w-1/2 mr-5"
              onClick={() => onCancel()}
              htmlType="button"
            >
              Cancelar
            </Button>
          
          <Button type="primary" classes="w-1/2" htmlType="submit">
            Continuar
          </Button>
        </div>

      </Form>
    </div>
  )
}

interface CashFormProps {
 
}

interface options {
  value: string
  text: string
}

enum valuesEnum {
  national = 'nationalTransfer',
  mobile = 'mobilePayment',
}

interface Bill {
  quantity: number
  amountCash: number
}